import React from "react";
import "../../components/Box.css";
import "./Home.css";
import SideNav from "../../components/SideNav/SideNav.js";


function Home() {

  return(
    <div>
      <SideNav name="Soumik Das" width="100vw"/>
    </div>
  )

}

export default Home;